export const FIRST_ROOT_SECTION_NUMBER = '01';
export const MAX_SECTION_DEPTH = 1;

export const ACCORDION_UNMOUNT_ON_EXIT_SLOT_PROPS = {
  transition: { unmountOnExit: true },
};
